/**
 * filterBlock
 */

import $ from 'jquery';

// Module dependencies
import 'protons';

// Module styles
import './_filter-block.scss';
import './_better-exposed-filters.scss';

// Module template
import './_filter-block.twig';

export const name = 'filterBlock';

export const defaults = {
  dummyClass: 'js-filterBlock-exists',
};

/**
 * Components may need to run clean-up tasks if they are removed from DOM.
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Pertinent settings
 */
// eslint-disable-next-line no-unused-vars
export function disable($context, settings) {}

export function enable($context) {
  // Find our component within the DOM
  const $filterBlock = $('.filter-block', $context);
  const $bioView = $('.bio-view', $context);
  const $appsView = $('.fm-digital-products__wrapper', $context);

  // Bail if component does not exist
  if (!$filterBlock.length) {
    return;
  }

  $bioView.find('.filter-block__toggle').text(Drupal.t('Filter'));

  $bioView.on('click', '.filter-block__toggle', () => {
    $bioView.find('.filter-block__filter-list').toggleClass('filter-open');
  });

  $appsView.on('click', '.filter-block__toggle', () => {
    $appsView.find('.fm-bef-radio').toggleClass('filter-open');
  });

  $bioView.on('click', '.filter-block__filter-item', el => {
    const activeItem = $(el.currentTarget).data('value');
    $bioView.find('.filter-block__toggle').text(activeItem.toUpperCase());
    $bioView.find('.filter-block__filter-list').removeClass('filter-open');
  });

  if ($appsView.find('input:checked')) {
    const activeItem = $appsView
      .find('input:checked')
      .next('label')
      .text();
    $appsView.find('.filter-block__toggle').text(activeItem.toUpperCase());
  } else {
    $appsView.find('.filter-block__toggle').text(Drupal.t('Filters'));
  }
}
export default enable;
